// カート画面注意事項

document.addEventListener('DOMContentLoaded', () => {

    if (!document.querySelector('#cart-agreement-box')) return;
  
    const confirmCheckbox = document.getElementById('cart_agreement_confirm');
    const hiddenAgreement = document.getElementById('cart_agreement_attribute');
    const hiddenTimestamp = document.getElementById('cart_agreement_timestamp');
    const error = document.getElementById('cart_agreement_error');
    const cartForm = document.querySelector('form.cart-page');
    const checkoutButtons = cartForm ? cartForm.querySelectorAll('[name="checkout"]') : [];
  
    if (!cartForm || !confirmCheckbox || !hiddenAgreement) return;
  
    const validateAgreement = () => {
      const isValid = confirmCheckbox.checked;
  
      hiddenAgreement.value = isValid ? '同意済み' : '未同意';
      hiddenTimestamp.value = isValid ? new Date().toISOString() : '';
  
      if (error) error.hidden = isValid;
  
      return isValid;
    };
  
    confirmCheckbox.addEventListener('change', validateAgreement);
  
    checkoutButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        if (!validateAgreement()) {
          event.preventDefault();
          confirmCheckbox.focus();
        }
      });
    });
  
    cartForm.addEventListener('submit', (event) => {
      if (!validateAgreement()) {
        event.preventDefault();
        confirmCheckbox.focus();
      }
    });
  
  });